export const get_layer_page_category_and_subcategory = (currentPage) => {
    const {
        isCategory,
        //isComponentsLibrary,
        isCheckout,
        isCheckoutConfirmation,
        //isRegistrationConfirmation,
        //isRegistrationCompletePage,
        isCart,
        isProductDetail,
        //isMaintenance,
        //isPaperless,
        //isWishlistPage,
        isPsp,
        isSearchPage,
        isContactUs,
        isFaq,
        isHomePage,
        isAuthorizedServiceCenter,
        isLogin,
        isRegistration,
        isAccount,
    } = currentPage

    if (isCategory) return {page_category: 'category', page_subcategory: 'micro'}
    if (isProductDetail) return {page_category: 'detail', page_subcategory: ''}
    if (isPsp) return {page_category: 'category', page_subcategory: 'macro'}

    if (isCheckoutConfirmation) return {page_category: 'checkout', page_subcategory: 'purchase'}
    if (isCart) return {page_category: 'checkout', page_subcategory: 'cart'}
    if (isCheckout) return {page_category: 'checkout', page_subcategory: 'checkout'}

    if (isSearchPage) return {page_category: 'search', page_subcategory: ''}
    if (isContactUs) return {page_category: 'customer_service', page_subcategory: 'other'}
    if (isFaq) return {page_category: 'customer_service', page_subcategory: 'faq'}
    if (isHomePage) return {page_category: 'home', page_subcategory: ''}
    if (isAuthorizedServiceCenter) return {page_category: 'service_locator', page_subcategory: ''}
    if (isLogin) return {page_category: 'reserved_area', page_subcategory: 'login_form'}
    if (isRegistration)
        return {page_category: 'reserved_area', page_subcategory: 'registration_form'}
    if (isAccount) return {page_category: 'reserved_area', page_subcategory: 'reserved'}

    return {page_category: '', page_subcategory: ''}
}

export const get_layer_page_category = () => {}

export const get_layer_page_subcategory = () => {}

export const retrieve_status_code_gtm = () => {
    const statusElement = document?.querySelector('[data-status-code]')
    if (statusElement) return statusElement?.getAttribute('data-status-code')
    else return 200
}

export const page_view = (data) => ({
    event: 'page_view',
    page_path: data.page_path || '',
    page_title: document.title,
    page_location: window.location.href,
})

export const virtual_page_view = (data) => ({
    event: data.event || 'virtualPageview',
    virtualUrl: data.virtualUrl || '',
    userId: data?.c_gigyaId || '',
    emailMD5: data.emailMD5 || '',
    emailSHA256: data.emailSHA256 || '',
    email: data.email || '',
    name: data.name || '',
    surname: data.surname || '',
    device: data.device || '',
    eCommerceSite: data.eCommerceSite || true,
    pageCountry: data.pageCountry || 'gb',
    pageLanguage: data.pageLanguage || 'en',
    pageCategory: data.pageCategory || '',
    pageSubCategory: data.pageSubCategory || '',
    statusCode: data.statusCode || 200,
})

export const virtual_page_view_no_customer = (data) => ({
    event: data.event || 'virtualPageview',
    virtualUrl: data.virtualUrl || '',
    device: data.device || '',
    eCommerceSite: data.eCommerceSite || true,
    pageCountry: data.pageCountry || 'gb',
    pageLanguage: data.pageLanguage || 'en',
    pageCategory: data.pageCategory || '',
    pageSubCategory: data.pageSubCategory || '',
    statusCode: data.statusCode || 200,
})

export const basic_gtm_event = (data) => ({
    event: data.event || null,
    eventCategory: data.eventCategory || null,
    eventAction: data.eventAction || null,
    eventLabel: data.eventLabel || null,
    ...(data.method && {method: data.method}),
    ...(data.resultsAmount !== undefined &&
        data.resultsAmount !== null && {resultsAmount: data.resultsAmount}), // Add also 0 value
    ...(data.eventDetail && {eventDetail: data.eventDetail}),
    ...(data.userId && {userId: data.userId}),
    ...(data.email && {email: data.email}),
    ...(data.emailSHA256 && {emailSHA256: data.emailSHA256}),
})

export const item_gtm_event = (data) => ({
    event: data.event || null,
    ecommerce: {
        ...(data.item_list_name && {item_list_name: data.item_list_name}),
        ...(data.currency && {currency: data.currency}),
        ...(data.bundle && {bundle: data.bundle}),
        ...(data.bundle_id && {bundle_id: data.bundle_id}),
        ...(data.value && {value: data.value}),
        items: data.items || null,
    },
})

export const polish_ecommerce_gtm_event = () => ({
    ecommerce: null,
})

export const simple_gtm_event = (data) => ({
    event: data.event || null,
})

export const get_reevoo_rating = () => {
    const reevoo = window?.document?.querySelector('reevoo-badge')
    if (reevoo) {
        const reevooIframe = reevoo?.querySelector('iframe')
        const reevooDoc = reevooIframe?.contentWindow?.document
        const reviewsBody = reevooDoc?.querySelector('body')
        const innerDiv = reviewsBody?.querySelector('div[data-feefo-action="reviews"]')
        const reevooRatingDiv = innerDiv?.querySelector('reevoo-stars')
        const ratingPoints = reevooRatingDiv?.getAttribute('data-score')
        if (ratingPoints) return ratingPoints
        else return '0.0'
    } else return null
}

export const get_bv_rating = () => {
    const bazaarVoiceRating = window?.document?.querySelector('.bv_text')
    if (bazaarVoiceRating) return bazaarVoiceRating?.textContent
    else return
}

export const get_reevoo_multiple = () => {
    const reevoo = window?.document?.querySelectorAll('reevoo-badge')
    if (reevoo) {
        //?map through all reevoo elements and get the rating points
        const reevooRatingPoints = Array.from(reevoo).map((item) => {
            const reevooIframe = item?.querySelector('iframe')
            const reevooDoc = reevooIframe?.contentWindow?.document
            const reviewsBody = reevooDoc?.querySelector('body')
            const innerDiv = reviewsBody?.querySelector('div[data-feefo-action="reviews"]')
            const reevooRatingDiv = innerDiv?.querySelector('reevoo-stars')
            const ratingPoints = reevooRatingDiv?.getAttribute('data-score')
            if (ratingPoints) return ratingPoints
            else return '0.0'
        })
        return reevooRatingPoints
    } else return null
}

export const get_bv_multiple = () => {
    const bazaarVoiceRating = window?.document?.querySelectorAll('.bv_text')
    if (bazaarVoiceRating) {
        const bazaarVoiceRatingPoints = Array.from(bazaarVoiceRating).map(
            (item) => item?.textContent,
        )
        return bazaarVoiceRatingPoints
    }
}
